import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BranchesService } from 'src/app/services/branches/branches.service';
import { OurTeamService } from 'src/app/services/our-team/our-team.service';
import { ActivatedRoute } from '@angular/router';
import { CryptService } from 'src/app/services/crypt.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import * as XLSX from 'xlsx';
import { DomSanitizer } from '@angular/platform-browser';
import * as $ from 'jquery';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
type AOA = any[][];
// declare var $: any;
// $.fn.DataTable = require('datatables.net');
import 'datatables.net';
import 'datatables.net-bs4';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

export class details {
  public key: string;
  public value: string;
}

export class PostOrder {
  public PostId: string;
  public OrderDisplay: number;
}

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class OurTeamComponent implements OnInit {
  dataTable: any;
  public Editor = ClassicEditor;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '1',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],

    uploadWithCredentials: true,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['toggleEditorMode']],
  };
  groupCtrl = new UntypedFormControl();
  filteredGroup: Observable<string[]>;
  selectedGroup = '';
  public form: UntypedFormGroup;
  unsubcribe: any;
  img_defulat: string =
    'data:image/jpeg;base64,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';
  public files = [];
  public groups: any[];
  file: File = null;
  aspectRatio:any='4 / 3';
  resizeToWidth: number = 0;
  resizeToHeight: number = 0;
  imageQuality: number = 0;
  formatImage: string = '';
  hideFile: boolean = true;
  hideEditor: boolean = true;
  hideImages: boolean = true;
  showDataExported: boolean = false;
  nameType: string = '';

  showImage: boolean = true;
  NewsIsHome: any = false;
  d: details[] = [];

  ArrayPostOrder: PostOrder[] = [];

  id: any;
  year_: string;
  LANG_ = this.c.Decrypt(sessionStorage.getItem('syslang'));
  BRN_ = this.c.Decrypt(sessionStorage.getItem('brnId'));
  TYPE_ = '';
  brnTitle = this.c.Decrypt(sessionStorage.getItem('brnTitle'));

  @ViewChild(MatSelect) gets: MatSelect;
  @ViewChild('Statu') matSelect: MatSelect;
  @ViewChild('template') template: TemplateRef<any>;
  loadPage = true;
  rowsPage: number;
  isLoadingResults = true;
  isRateLimitReached = false;
  Status: any;
  selected;
  selectedValue: string;
  selectedLang: string;
  ShowOrder: boolean = true;
  selectedLang_Table: string;
  selected_icon: string;
  selectedCategories: string;
  canvasRotation;
  ProdTitle: string = '';
  ProdSub: string = '';
  ProdDetails: string = '';
  ProdIsHome: any = false;
  showSave: boolean = false;
  showSaveContinue: boolean = false;
  showcancel: boolean = false;
  showNew: boolean = true;
  name: string;
  showUpdate: boolean = false;
  showDataPanle: boolean = false;
  languages: any;
  Years: any;
  YearsDrop: any;
  Categories: any;
  ProdId: string = '';

  imageChangedEvent: any = '';
  croppedImage: any = '';
  imgUrl: string = '';
  imgUrl2: any = '';

  id_delete: string;
  id_lang: string;
  PostFIleName: string;
  pageNumbers;
  message;
  disableSelect;
  tableProd;
  selectedRows;
  showTableProd: boolean = false;
  showIcons: boolean = true;
  NameIcon: string = '';
  AboLink: string;
  selected1;

  selectedBrn;
  branches;
  EventsArray = [];
  AboTitle1: string = '';
  MaxFileSize: number = 0;
  MaxFileSizeMsg = '';
  MaxFileSizeMsg2 = '';
  uploadFile(event: any) {
    if (this.LANG_ == 'Ar') {
      this.MaxFileSizeMsg = 'يجب ان يكون حجم الملف اصغر او يساوي ';
      this.MaxFileSizeMsg2 = 'حسنا';
    } else {
      this.MaxFileSizeMsg = 'The file size must be less than or equal to ';
      this.MaxFileSizeMsg2 = 'OK';
    }
    // for (let index = 0; index < event.length; index++) {
    this.deleteAttachment(0);
    const element = event[0];

    if (Math.round(element.size / (1024 * 1024)) <= this.MaxFileSize) {
      this.files.push(element.name);
      this.file = element;
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      this.PostFileDB = 'New';
    } else {
      this._snackBar.open(
        this.MaxFileSizeMsg + this.MaxFileSize + ' MB',
        this.MaxFileSizeMsg2,
        {
          duration: 5000,
          horizontalPosition: 'left',
        }
      );
    }
    // }
  }
  deleteAttachment(index) {
    this.file = null;
    this.PostFileDB = 'null';
    this.files.splice(index, 1);
  }
    //Function To Filtering Categoriescm Data
    private _filterGroup(value: string): string[] {
      const filterValue = value.toLowerCase();
  
      return this.Categories.filter((state) =>
        state.PostTitle.toLowerCase().includes(filterValue)
      );
    }
  // For Filter
  openPanelOfGroup() {
    this.filteredGroup = this.groupCtrl.valueChanges.pipe(
      startWith(''),
      map((data) =>
        data
          ? this._filterGroup(data)
          : this.Categories.slice()
      )
    );
  }
  selectedOption:any;
  selectedCategories2:any;
  getGroupValue(event: any) {
   this.selectedOption = this.Categories.find(option => option.PostTitle === event.option.value);
   this.selectedCategories = this.selectedOption.PostId;   
   this.selectedCategories2 = this.selectedOption.PostTitle;
    }
  getGroupValueId(event: any) {
   this.selectedOption = this.Categories.find(option => option.PostId === event);
  //  this.selectedCategories = this.selectedOption.PostId;   
   this.selectedCategories2 = this.selectedOption.PostTitle;
    }
  // import file excel
  data: AOA = [];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'SheetJS.xlsx';
  headers: any;
  arrayPostData: any[] = [];
  onFileChange(event: any) {
    this.loadPage = false;
    this.dataHeader = [];
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      this.headers = jsonData[0];
      const rows = jsonData.slice(1);
      const jsonRows = rows.map((row) => {
        const obj = {};
        this.headers.forEach((header, index) => {
          obj[header] = row[index];
        });
        return obj;
      });

      // this.data = jsonRows;
      this.arrayPostData = jsonRows;
    };
    reader.readAsBinaryString(file);
    this.readExcelFile(file);
    this.showDataExported = true;
    this.loadPage = true;
    // this.dataTable = $('#excelTable').DataTable();
    // const data = this.dataTable.rows().data().toArray();
    // const jsonData = JSON.stringify(data);
  }
  // read excel file and show it in table
  dataHeader: any = [];
  readExcelFile(file: File): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        resolve(data);
        this.dataHeader = data;
      };

      fileReader.onerror = (error) => {
        reject(error);
      };

      fileReader.readAsBinaryString(file);
    });
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    
    this.showImage = false;
  }
  // for export excel file with headers
  headers_ = [
    'م',
    'رقم الجلوس',
    'الاسم',
    'الرياضيات 25%',
    'العلوم 20%',
    'العربي 25%',
    'الإنجليزي 10%',
    'الذكاء 10%',
    'تاسع 10%',
    'الإجمالي',
  ];
  exportHeadersToExcel() {
    const worksheet = XLSX.utils.json_to_sheet([], { header: this.headers_ });
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveExcelFile(excelBuffer, 'نتائج القبول');
  }
  saveExcelFile(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName + '.xlsx';
    link.click();
  }
  // End

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    
    
  }
  cut() {
    this.showImage = true;
  }
  closeIcon() {
    this.showIcons = true;
  }
  showIcon() {
    this.showIcons = false;
  }
  getNameIcon(Icons) {
    this.NameIcon = Icons;
    this.showIcons = true;
  }

  // imageLoaded() {}

  cropperReady() {}

  loadImageFailed() {}

  getDataProd(): void {
    this.getRows('1');
    this.loadPage = true;
  }
  hideSection: Boolean;
  PostFilePath: string = '';
  PostFileDB: string = '';
  id_delete_img = '';
  showData(id, langId): void {
        this.loadPage = false;
    this.clearData();
    this.ProdIsHome = false;
    this.disableSelect = null;
    this.Prod.GetOurTeamWhereSection(id, langId).subscribe((data) => {      
      this.ProdId = data[0]['Id'];
      this.ProdTitle = data[0]['PostTitle'];
      this.ProdSub = data[0]['PostDsc'];
      this.ProdDetails = data[0]['PostDetails'];
      this.ProdIsHome = Boolean(data[0]['PostIsHome']);
      this.selected = data[0]['StateID'];
      this.selectedLang = data[0]['Lang'];
      this.PostFileDB = data[0]['PostFile'];
      this.PostFilePath = this.Prod.imageUrl() + data[0]['PostFile'];

      if (this.PostFileDB != null) {
        this.files.push(this.PostFilePath);
      } else {
        this.PostFilePath = null;
      }

      this.croppedImage = data[0]['base64'];
      try {
      } catch {}
      this.BRN_ = data[0]['FbrnId'];


      setTimeout(() => {
        this.Prod.GetsectionOurTeam(
          data[0]['Lang'],
          this.BRN_,
          data[0]['MTYPE']
        ).subscribe((dataCat) => {
          this.Categories = dataCat;
          console.log("nbnb",this.Categories);
          
          let arr = dataCat as any[];
          if (arr.length == 1) {
            if (data[0]['PostId'] == 'NTROOT0') {
              this.hideSection = true;
              this.DisCategories = new UntypedFormControl(false);
              this.selectedCategories = dataCat[0]['PostId'];
              // this.selectedCategories2 = data[0]['PostTitle'];
            } else {
              this.hideSection = false;
              
              this.DisCategories = new UntypedFormControl(false);
              this.selectedCategories = dataCat[0]['PostId'];
              
            }
          } else if (arr.length > 1) {
            this.DisCategories = false;
            // this.selectedCategories = data[0]['PostId'];
            // this.selectedCategories2 = dataCat[0]['PostTitle'];
            this.getGroupValueId(this.selectedCategories)

          }
        });
      }, 100);

      this.hideSection = false;
      if (data[0]['PostId'] == 'NTROOT0') {
        this.DisCategories = new UntypedFormControl(false);
        this.hideSection = true;
      }
      this.selectedCategories = data[0]['PostId'];
      // this.selectedCategories2 = data[0]['PostTitle'];
      this.Prod.GetPostMetaVal(
        'GetPostMetaVal',
        id,
        this.TYPE_,
        langId
      ).subscribe((data:any) => {
        let x = data[0]['column1'];

        if(data.length != 0 || x  != null || x  != 'null')
        {
        this.form.setValue(JSON.parse('{' + data[0]['column1'] + '}'));
        }
      });
      this.loadPage = true;
    });
    this.btnUpdate();
    this.disableSelect = new UntypedFormControl(false);
  }

  DisBrn;

  showProdlang(id, langId): void {
    this.disableSelect = null;

    this.clearData();
    this.ProdIsHome = false;
    this.Prod.GetOurTeamWhereSection(id, langId).subscribe((data) => {
      this.ProdId = data[0]['PostId'];
      this.ProdTitle = data[0]['PostTitle'];
      this.ProdSub = data[0]['PostDsc'];
      this.PostFileDB = data[0]['PostFile'];
      this.PostFilePath = this.Prod.imageUrl() + data[0]['PostFile'];

      if (this.PostFileDB != null) {
        this.files.push(this.PostFilePath);
      } else {
        this.PostFilePath = null;
      }

      try {
        this.croppedImage = data[0]['base64'];
      } catch {}
      this.ProdDetails = data[0]['PostDetails'];
      this.ProdIsHome = Boolean(data[0]['PostIsHome']);

      this.selected = '';
      this.selectedLang = '';
      this.imgUrl = this.img_defulat;

      this.Prod.GetOurTeamLang(id).subscribe((data) => {
        this.languages = null;
        this.languages = data;
      });
    });

    this.btnNew();
  }

  toggle(): void {
    this.showSave = !this.showcancel;
  }

  btnNew() {
    this.disableSelect = null;
    this.showSave = true;
    this.showSaveContinue = true;
    this.showcancel = true;
    this.selectedCategories = '';
    this.showNew = false;
    this.hideSection = true;
    this.showDataPanle = true;
    this.showUpdate = false;
    this.clearData();
    this.clearData2();
    this.showTableProd = true;
  }
  btnclose() {
    this.showSave = false;
    this.showcancel = false;
    this.showNew = true;
    this.showDataPanle = false;
    this.showUpdate = false;
    this.clearData();
    this.showTableProd = false;
    this.getDataProd();
  }
  btnUpdate() {
    this.showDataPanle = true;
    this.showSave = false;
    this.showSaveContinue = false;
    this.showcancel = true;
    this.showUpdate = true;

    this.showNew = false;
    this.showTableProd = true;
  }

  btnExport() {}

  modalRef: BsModalRef;
  constructor(private sanitizer: DomSanitizer,
    private c: CryptService,
    private _Activatedroute: ActivatedRoute,
    private brn: BranchesService,
    private Prod: OurTeamService,
    private _snackBar: MatSnackBar,
    private modalService: BsModalService
  ) {
    this._Activatedroute.paramMap.subscribe((params) => {
      this.ngOnInit();
      this.TYPE_ = this._Activatedroute.snapshot.paramMap.get('name');
    });
   
  }  
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  delete(template: TemplateRef<any>, id, langId, PostFile): void {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
    this.id_delete = id;
    this.id_lang = langId;
    this.PostFIleName = PostFile;
  }
  deleteImg(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
    this.id_delete = this.ProdId;

    // this.id_lang = langId;
    // this.PostFIleName = PostFile;
  }

  confirmImg(): void {
    this.loadPage = false;
    this.Prod.OurTeamPost(
      'dimg',
      this.ProdId,
      this.TYPE_,
      this.selectedCategories,
      '',
      '',
      '',
      '',
      '',
      '',
      this.BRN_,
      this.c.Decrypt(sessionStorage.getItem('usrId')),
      this.selected,
      this.selectedLang,
      '',
      '',
      ''
    ).subscribe((data) => {
      this.croppedImage = this.img_defulat;
      console.log("dhg",data);
      
      this._snackBar.open(data[0]['column1'], 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      this.loadPage = true;
    });
    this.id_delete_img = '';
    // this.id_lang = '';
    // this.PostFIleName = '';
    this.modalRef.hide();
  }
  confirm(): void {
    this.loadPage = false;
    this.Prod.deleteProd(
      'd',
      this.id_delete,
      this.id_lang,
      this.PostFIleName
    ).subscribe((data) => {
      this.getDataProd();
      this.clearData();

      this._snackBar.open(data[0]['column1'], 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      this.loadPage = true;
    });
    this.id_delete = '';
    this.id_lang = '';
    this.PostFIleName = '';
    this.modalRef.hide();
  }

  decline(): void {
    this.message = 'Declined!';
    this.modalRef.hide();
  }

  Validation(): boolean {
    if (this.selectedLang == '' || this.selectedLang == null) {
      this._snackBar.open('الرجاء اختيار لغة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    } else if (
      this.selectedCategories == '' ||
      this.selectedCategories == null
    ) {
      this._snackBar.open('الرجاء اختيار قسم اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    } else if (this.selected == null) {
      this._snackBar.open('الرجاء اختيار الحالة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    } else if (this.ProdTitle == '' || this.ProdTitle == null) {
      this._snackBar.open('الرجاء ادخال العنوان اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    } else if (this.croppedImage == '' || this.croppedImage == null) {
      this._snackBar.open('الرجاء اختيار صورة اولا', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    }
    return true;
  }
  Validation2(): boolean {
    if (this.selectedLang == '' || this.selectedLang == null) {
      this._snackBar.open('الرجاء اختيار لغة ', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    } else if (
      this.selectedCategories == '' ||
      this.selectedCategories == null
    ) {
      this._snackBar.open('الرجاء اختيار العام ', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    } else if (this.dataHeader.length == 0) {
      this._snackBar.open('الرجاء استيراد ملف الاكسل', 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      return false;
    }
    return true;
  }
  clearData(): void {
    this.files = [];
    this.PostFileDB = '';
    this.PostFilePath = '';
    this.file = null;
    this.ProdTitle = '';
    this.ProdSub = '';
    this.ProdDetails = '';
    this.ProdIsHome = false;
    this.selected = '';
    this.selectedLang = '';
    this.selectedBrn = '';
    this.imageChangedEvent = '';
    this.selectedCategories2 = '';
    this.DisCategories = false;
    this.croppedImage = this.img_defulat;
    this.imgUrl = '';
    this.selectedCategories = '';
    this.ProdId = null;
    this.EventsArray = [];
    this.hideSection=true;
    this.Prod.GetOurTeamLang(null).subscribe((data) => {
      this.languages = data;
    });
  }
  clearData2(): void {
    this.selectedCategories = '';
    this.dataHeader = [];
    this.Prod.GetOurTeamLang(null).subscribe((data) => {
      this.languages = data;
    });
  }

  update(): void {
    this.showUpdate = false;
    this.loadPage = false;

    if (this.Validation()) {
      this.dynamicSave();

      this.Prod.OurTeamPost(
        'u',
        this.ProdId,
        this.TYPE_,
        this.selectedCategories,
        this.ProdTitle,
        this.ProdTitle,
        this.ProdIsHome,
        this.ProdSub,
        this.ProdDetails,
        this.croppedImage,
        this.BRN_,
        this.c.Decrypt(sessionStorage.getItem('usrId')),
        this.selected,
        this.selectedLang,
        JSON.stringify(this.d),
        this.file,
        this.PostFileDB
      ).subscribe((data) => {
        this.getDataProd();
        this.clearData();
        this.btnclose();
        this._snackBar.open(data[0]['column1'], 'حسنا', {
          duration: 5000,
          horizontalPosition: 'left',
        });
        this.loadPage = true;
      });
    } else {
      this.showUpdate = true;
      this.loadPage = true;
    }
    this.ProdId = '';
  }

  save(): void {
    this.loadPage = false;
    this.showSave = false;

    if (this.Validation()) {
      this.dynamicSave();

      this.Prod.OurTeamPost(
        'i',
        this.ProdId,
        this.TYPE_,
        this.selectedCategories,
        this.ProdTitle,
        this.ProdTitle,
        this.ProdIsHome,
        this.ProdSub,
        this.ProdDetails,
        this.croppedImage,
        this.BRN_,
        this.c.Decrypt(sessionStorage.getItem('usrId')),
        this.selected,
        this.selectedLang,
        JSON.stringify(this.d),
        this.file,
        this.PostFileDB
      ).subscribe((data) => {
        this.getDataProd();
        this.clearData();
        this.btnclose();

        this._snackBar.open(data[0]['column1'], 'حسنا', {
          duration: 5000,
          horizontalPosition: 'left',
        });
        this.loadPage = true;
      });
    } else {
      this.showSave = true;
      this.loadPage = true;
    }
  }
  saveandcontinue(): void {
    this.loadPage = false;
    // this.showSave = false;

    if (this.Validation()) {
      this.dynamicSave();

      this.Prod.OurTeamPost(
        'i',
        this.ProdId,
        this.TYPE_,
        this.selectedCategories,
        this.ProdTitle,
        this.ProdTitle,
        this.ProdIsHome,
        this.ProdSub,
        this.ProdDetails,
        this.croppedImage,
        this.BRN_,
        this.c.Decrypt(sessionStorage.getItem('usrId')),
        this.selected,
        this.selectedLang,
        JSON.stringify(this.d),
        this.file,
        this.PostFileDB
      ).subscribe((data) => {
        // this.getDataProd();
        // this.clearData();
        // this.btnclose();
        this.showSave = true;
        this.showSaveContinue = true;
        this._snackBar.open(data[0]['column1'], 'حسنا', {
          duration: 5000,
          horizontalPosition: 'left',
        });
        this.loadPage = true;
      });
    } else {
      this.loadPage = true;
    }
  }

  btnCloseOrderClick() {
    this.ShowOrder = true;
    this.getDataProd();
  }
  btnSaveOrderClick() {
    this.Prod.OrderPost('', JSON.stringify(this.ArrayPostOrder)).subscribe(
      (data) => {
        this._snackBar.open(data[0]['Column3'], 'حسنا', {
          duration: 5000,
          horizontalPosition: 'left',
        });
        this.btnCloseOrderClick();
      }
    );
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.tableProd, event.previousIndex, event.currentIndex);
    let index = this.indexFirst;
    this.ArrayPostOrder = [];
    this.tableProd.forEach((element) => {
      this.ArrayPostOrder.push({
        PostId: element.postId,
        OrderDisplay: index++,
      });
    });
    this.ShowOrder = false;
  }

  indexFirst: number;
  getRows(num) {
    if (this.rowsPage == null) this.rowsPage = 10;
    this.Prod.viewProdPaging(
      num,
      this.rowsPage,
      this.BRN_,
      this.LANG_,
      this.TYPE_
    ).subscribe((data) => {
      this.tableProd = data['data1'];
      this.indexFirst = data['data1'][0]['displayOrder'];
      this.pageNumbers = data['data2'];
    });
    this.ShowOrder = true;
  }
  getPage(event: any) {
    this.ShowOrder = true;

    this.rowsPage = event.target.value;
    this.Prod.viewProdPaging(
      1,
      this.rowsPage,
      this.BRN_,
      this.LANG_,
      this.TYPE_
    ).subscribe((data) => {
      this.tableProd = data['data1'];
      this.pageNumbers = data['data2'];
    });
  }

  DisCategories;

  onChangeLang() {
    setTimeout(() => {
      if (this.selectedLang == null || this.selectedLang == '') {
        console.log('Lang Null ..');
      } else {
        this.Prod.GetsectionOurTeam(
          this.selectedLang,
          this.BRN_,
          this.TYPE_
        ).subscribe((data) => {
          this.Categories = data;

          if (data.length == 1) {
            if (data[0]['PostId'] == 'NTROOT0') {
              this.hideSection = true;
              this.DisCategories = new UntypedFormControl(false);
              this.selectedCategories = data[0]['PostId'];
            } else {
              this.hideSection = false;
              this.DisCategories = new UntypedFormControl(false);
              this.selectedCategories = data[0]['PostId'];
            }
          } else {
            this.hideSection = false;
            this.DisCategories = false;
          }
        });
      }

      if (this.selectedLang == null || this.selectedLang == '') {
        console.log('Lang Null ...');
      } else {
        this.brn.getBrnWhereLangId(this.selectedLang).subscribe((data) => {
          this.branches = data;

          if (data.length == 1) {
            this.DisBrn = new UntypedFormControl(false);
            this.selectedBrn = data[0]['BrnId'];
          } else if (data.length > 1) {
            this.DisCategories = false;
          }
        });
      }
    }, 100);
  }

  dynamicFormArray: any;

  hideItem: boolean;

  // dynamicSave() {
  //   this.d = [];
  //   if (this.form.valid) {
  //     this.groups.forEach((g) => {
  //       this.form.addControl(g.name, new UntypedFormGroup({}));
  //       const group = this.form.get(g.name) as UntypedFormGroup;
  //       g.fields.forEach((x) => {
  //         // if (x.type == 'NT_check') {
  //         //   group.addControl(x.name, new FormGroup({}))
  //         //   x.options.forEach(o => {
  //         //      (group.get(x.name) as FormGroup).addControl(o.key, new FormControl(''))
  //         //   })
  //         // }
  //         // else {
  //         group.addControl(
  //           x.name,
  //           new UntypedFormControl('', x.required ? Validators.required : null)
  //         );
  //         this.d.push({ key: x.name, value: group.get(x.name).value });

  //         // }
  //       });
  //     });
  //     // alert(JSON.stringify(this.d))
  //   }
  // }
  dynamicSave() {
    this.d = [];
    if (this.form.valid) {
      
      this.groups.forEach((g) => {
        this.form.addControl(g.name, new UntypedFormGroup({}));
        const group = this.form.get(g.name) as UntypedFormGroup;
        g.fields.forEach((x) => {
          if (x.type == 'NT_check' && (this.showSave || this.showSaveContinue)) {
            // group.addControl(x.name, new FormGroup({}))
            // x.options.forEach(o => {
            //    (group.get(x.name) as FormGroup).addControl(o.key, new FormControl(''))
            // })
  
            group.addControl(
              x.name,
              new UntypedFormControl('', x.required ? Validators.required : null)
            );
            this.d.push({ key: x.name, value: x.value });
          }
          else {
          group.addControl(
            x.name,
            new UntypedFormControl('', x.required ? Validators.required : null)
          );
          this.d.push({ key: x.name, value: group.get(x.name).value });

          }
        });
      });
      // alert(JSON.stringify(this.d))
    }
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
}
  ngOnInit(): void {
    this.dataHeader = [];
    this.hideSection = true;
    this.showDataExported = false;

    this.TYPE_ = this._Activatedroute.snapshot.paramMap.get('name');
    this.Prod.SettingScreen(this.TYPE_, this.LANG_).subscribe((data) => {
      
      try {
        this.resizeToWidth = data[0]['NT_ImageWidth'];
        this.resizeToHeight = data[0]['NT_ImageHighet'];
        this.imageQuality = data[0]['NT_ImageSize'];
        this.aspectRatio = data[0]['NT_ImageAscpectRatio'];
        
        if(this.aspectRatio==null)
        {
          this.aspectRatio='4 / 3'
        }
        
        this.formatImage = data[0]['NT_ImageFormat'];
        this.MaxFileSize = data[0]['NT_MaxFileSize'];

        if (data[0]['NT_HasFile'] == '1') this.hideFile = false;
        else this.hideFile = true;
        if (data[0]['NT_HasEditor'] == '1') this.hideEditor = false;
        else this.hideEditor = true;
        if (data[0]['NT_HasImage'] == '1') this.hideImages = false;
        else this.hideImages = true;
        this.nameType = data[0]['M_Title'];

        if (this.formatImage == null || this.formatImage == 'undefined') {
          this.formatImage = 'jpeg';
        }
      } catch {}
      this.Prod.sysProperty('sysProperty', this.TYPE_, this.LANG_).subscribe(
        (data) => {
          let arr = data as any[];
          if (arr.length == 0) {
            this.groups = [];
          } else
            this.groups = JSON.parse(
              data[0]['jsoN_F52E2B61-18A1-11d1-B105-00805F49916B']
            );
          // alert(JSON.stringify(this.groups))
          setTimeout(() => {
            this.form = new UntypedFormGroup({});
            this.groups.forEach((g) => {
              this.form.addControl(g.name, new UntypedFormGroup({}));
              const group = this.form.get(g.name) as UntypedFormGroup;
              g.fields.forEach((x) => {
                // if (x.type == 'NT_check') {
                //   group.addControl(x.name, new FormGroup({}))
                //   x.options.forEach(o => {
                //     (group.get(x.name) as FormGroup).addControl(o.key, new FormControl(false))
                //   })
                // }
                // else {
                group.addControl(
                  x.name,
                  new UntypedFormControl('', x.required ? Validators.required : null)
                );
                // }
              });
            });
          }, 100);
        }
      );
    });

    // let  json = '[{ "one": { "firstName": "asdas", "lastName": "dasd", "email": "dasdsa" }, "two": { "picture": "", "country": "in", "gender": "f", "hobby": { "f": true, "c": true } } }]'
    // this.form.setValue(JSON.parse(json.substring(1,json.length-1)))

    this.btnNew();

    this.loadPage = false;
    this.clearData();
    this.btnclose();
    try {
      this.Prod.OurTeamStatus(this.TYPE_, this.LANG_).subscribe((data) => {
        this.Status = data;
      });
      this.Prod.GetOurTeamLang(this.ProdId).subscribe((data) => {
        this.languages = data;
      });
    } catch {
      console.log('خطأ غير متوقع');
    }
    try {
      this.getDataProd();
    } catch {
      console.log('خطأ غير متوقع');
    }
    if (this.TYPE_ == 'upload_result') {
      this.Prod.getPost(
        'getPost',
        '',
        this.LANG_,
        '',
        'Years',
        'NTROOT0',
        '',
        '-1'
      ).subscribe((data: any) => {
        this.Years = data;
      });

      this.getResultPass();
    }
  }

  getByLang() {
    setTimeout(() => {
      this.getRows('1');
      this.groups = [];
      this.Prod.sysProperty('sysProperty', this.TYPE_, this.LANG_).subscribe(
        (data) => {
          let arr = data as any[];
          if (arr.length == 0) {
            this.groups = [];
          } else
            this.groups = JSON.parse(
              data[0]['jsoN_F52E2B61-18A1-11d1-B105-00805F49916B']
            );
          // alert(JSON.stringify(this.groups))
          setTimeout(() => {
            this.form = new UntypedFormGroup({});
            this.groups.forEach((g) => {
              this.form.addControl(g.name, new UntypedFormGroup({}));
              const group = this.form.get(g.name) as UntypedFormGroup;
              g.fields.forEach((x) => {
                // if (x.type == 'NT_check') {
                //   group.addControl(x.name, new FormGroup({}))
                //   x.options.forEach(o => {
                //     (group.get(x.name) as FormGroup).addControl(o.key, new FormControl(false))
                //   })
                // }
                // else {
                group.addControl(
                  x.name,
                  new UntypedFormControl('', x.required ? Validators.required : null)
                );
                // }
              });
            });
          }, 100);
        }
      );
    }, 100);
  }
  getByYear() {
    this.ResultPass = [];

    this.Prod.getResult(
      'sadm',
      this.year_,
      '',
      this.BRN_,
      this.c.Decrypt(sessionStorage.getItem('usrId'))
    ).subscribe((data) => {
      this.ResultPass = data;
    });
  }
  postData() {
    if (this.Validation2()) {
      this.loadPage = false;
      this.Prod.getResult(
        'iadm',
        this.selectedCategories,
        JSON.stringify(this.arrayPostData),
        this.BRN_,
        this.c.Decrypt(sessionStorage.getItem('usrId'))
      ).subscribe((data) => {
        // this.ResultPass = data;
        this.getResultPass();
        this._snackBar.open(data[0]['column1'], 'حسنا', {
          duration: 5000,
          horizontalPosition: 'left',
        });
      });
      this.loadPage = true;
      this.showSave = false;
      this.showSaveContinue = false;
      this.showcancel = false;
      this.showNew = true;
      this.showDataPanle = false;
      this.showUpdate = false;
      this.clearData2();
      this.showTableProd = false;
    }
  }
  ResultPass: any = [];
  getResultPass() {
    this.Prod.getResult(
      'sy',
      '',
      '',
      this.BRN_,
      this.c.Decrypt(sessionStorage.getItem('usrId'))
    ).subscribe((data: any) => {
      this.YearsDrop = data;

      let arr = data as any[];
      this.year_ = arr[arr.length - 1]['year_id'];
      this.Prod.getResult(
        'sadm',
        this.year_,
        '',
        this.BRN_,
        this.c.Decrypt(sessionStorage.getItem('usrId'))
      ).subscribe((data) => {
        this.ResultPass = data;
      });
    });
  }
  delResults(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }
  confirmDel() {
    this.loadPage = false;
    this.Prod.getResult(
      'dy',
      this.year_,
      '',
      this.BRN_,
      this.c.Decrypt(sessionStorage.getItem('usrId'))
    ).subscribe((data) => {
      this.croppedImage = this.img_defulat;
      this._snackBar.open(data[0]['column1'], 'حسنا', {
        duration: 5000,
        horizontalPosition: 'left',
      });
      this.ResultPass = [];
      this.getResultPass();
      this.loadPage = true;
    });
    this.modalRef.hide();
  }
}
